import { createSlice } from "@reduxjs/toolkit";
import { postMethod } from "../../services/ApiCallMethods";
import { createAsyncThunk } from "@reduxjs/toolkit";

export const resendBulkInvite = createAsyncThunk(
  "bulkAction/resendBulkInvite",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postMethod(`/api/resend-bulk-invite`, payload);
      const data = await response.json();
      if (data?.error) return rejectWithValue(data.error);
      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to resend invite");
    }
  }
);

export const bulkActivation = createAsyncThunk(
  "bulkAction/bulkActivation",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postMethod(`/api/users/bulk-activate`, payload);
      const data = await response.json();
      if (data?.error) return rejectWithValue(data.error);
      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to resend invite");
    }
  }
);

export const bulkDeactivation = createAsyncThunk(
  "bulkAction/bulkDeactivation",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await postMethod(`/api/users/bulk-deactivate`, payload);
      const data = await response.json();
      if (data?.error) return rejectWithValue(data.error);
      return data;
    } catch (error) {
      return rejectWithValue(error?.message || "Failed to resend invite");
    }
  }
);

const bulkActionSlice = createSlice({
  name: "bulkAction",
  initialState: {
    loading: false,
    resendError: null,
    activationError: null,
    deactivationError:null,
    resendSuccess: null,
    activationSuccess: null,
    deactivationSuccess:null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(resendBulkInvite.pending, (state) => {
        state.loading = true;
        state.resendError = null;
      })
      .addCase(resendBulkInvite.fulfilled, (state, action) => {
        state.loading = false;
        state.resendSuccess = action.payload;
        state.resendError = null;
      })
      .addCase(resendBulkInvite.rejected, (state, action) => {
        state.loading = false;
        state.resendError = action.payload;
        state.resendSuccess = null;
      });

    builder
      .addCase(bulkActivation.pending, (state) => {
        state.loading = true;
        state.activationError = null;
      })
      .addCase(bulkActivation.fulfilled, (state, action) => {
        state.loading = false;
        state.activationSuccess = action.payload;
        state.activationError = null;
      })
      .addCase(bulkActivation.rejected, (state, action) => {
        state.loading = false;
        state.activationError = action.payload;
        state.activationSuccess = null;
      });

      builder
      .addCase(bulkDeactivation.pending, (state) => {
        state.loading = true;
        state.deactivationError = null;
      })
      .addCase(bulkDeactivation.fulfilled, (state, action) => {
        state.loading = false;
        state.deactivationSuccess = action.payload;
        state.deactivationError = null;
      })
      .addCase(bulkDeactivation.rejected, (state, action) => {
        state.loading = false;
        state.deactivationError = action.payload;
        state.deactivationSuccess = null;
      });
  },
});

export default bulkActionSlice.reducer;
